import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// DragHandle.tsx
// Componente visual para mostrar el icono de drag & drop en la tabla de reglas.

export const DragHandle = ({ id }: { id: string | number }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <span
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: isDragging ? 'grabbing' : 'grab',
        opacity: isDragging ? 0.5 : 1,
        marginRight: 8,
      }}
      title="Arrastrar para reordenar"
    >
      <svg
        width="10"
        height="14"
        viewBox="0 0 10 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_6458_1204)">
          <path
            d="M1.4 12.25V10.5H3.2V12.25H1.4ZM0.5 13.125H1.4H3.2H4.1V12.25V10.5V9.625H3.2H1.4H0.5V10.5V12.25V13.125ZM6.8 12.25V10.5H8.6V12.25H6.8ZM5.9 13.125H6.8H8.6H9.5V12.25V10.5V9.625H8.6H6.8H5.9V10.5V12.25V13.125ZM1.4 6.125H3.2V7.875H1.4V6.125ZM0.5 7.875V8.75H1.4H3.2H4.1V7.875V6.125V5.25H3.2H1.4H0.5V6.125V7.875ZM6.8 7.875V6.125H8.6V7.875H6.8ZM5.9 8.75H6.8H8.6H9.5V7.875V6.125V5.25H8.6H6.8H5.9V6.125V7.875V8.75ZM1.4 1.75H3.2V3.5H1.4V1.75ZM0.5 3.5V4.375H1.4H3.2H4.1V3.5V1.75V0.875H3.2H1.4H0.5V1.75V3.5ZM6.8 3.5V1.75H8.6V3.5H6.8ZM5.9 4.375H6.8H8.6H9.5V3.5V1.75V0.875H8.6H6.8H5.9V1.75V3.5V4.375Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_6458_1204">
            <rect
              width="9"
              height="14"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
